import { render, staticRenderFns } from "./WSectorsList.vue?vue&type=template&id=6e2c07c6&"
import script from "./WSectorsList.vue?vue&type=script&lang=ts&"
export * from "./WSectorsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports